'use client'

import { Avatar, Button, Icon, IconComponent } from '@graftcode/design-system'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'
import { getInitials, getWorkspaceLogoUrl } from '@common/components/Sidebar/Sidebar.helpers'

import { useMobileMenuContext } from '../../context'

import styles from '../../MobileMenu.module.scss'

export function WorkspacesView() {
  const {
    currentWorkspace,
    navigateToMain,
    onClose,
    onInviteWorkspaceClick,
    onOpenWorkspaceSettings,
    onWorkspaceClick,
    workspaces,
  } = useMobileMenuContext()

  const currentWorkspaceId = currentWorkspace?.workspaceId

  const handleSettingsClick = () => {
    onOpenWorkspaceSettings?.()
    onClose()
  }

  const handleInviteClick = () => {
    onInviteWorkspaceClick?.()
    onClose()
  }

  return (
    <div className={styles.menuView} data-testid={MOBILE_MENU_TEST_IDS.workspacesView}>
      <div className={styles.header}>
        <button className={styles.backButton} onClick={navigateToMain}>
          <IconComponent icon={Icon.ChevronLeftRegular} size={24} />
          <span>Select Workspace</span>
        </button>
        <div className={styles.headerActions}>
          <Button iconOnly size="l" variant="ghost" icon={Icon.DismissRegular} onClick={onClose} />
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.submenuSection}>
          <div className={styles.submenuGroup}>
            <button
              className={`${styles.submenuItem} ${!onOpenWorkspaceSettings ? styles.disabled : ''}`}
              onClick={handleSettingsClick}
              disabled={!onOpenWorkspaceSettings}
            >
              <IconComponent icon={Icon.SettingsRegular} size={20} />
              <span>Settings</span>
            </button>
            <button
              className={`${styles.submenuItem} ${!onInviteWorkspaceClick ? styles.disabled : ''}`}
              onClick={handleInviteClick}
              disabled={!onInviteWorkspaceClick}
            >
              <IconComponent icon={Icon.PeopleAddRegular} size={20} />
              <span>Invite people</span>
            </button>
          </div>

          <div className={styles.submenuSeparator} />

          <div className={styles.submenuGroup}>
            <div className={styles.submenuGroupLabel}>Switch workspace</div>
            {workspaces.map((workspace) => {
              const isSelected = currentWorkspaceId === workspace.workspaceId
              const initials = getInitials(workspace.name)
              return (
                <button
                  key={workspace.workspaceId}
                  className={`${styles.submenuItem} ${isSelected ? styles.selected : ''}`}
                  onClick={() => onWorkspaceClick?.(workspace.workspaceId)}
                >
                  <div>
                    <Avatar size={20} src={getWorkspaceLogoUrl(workspace)} fallback={initials} />
                  </div>
                  <span>{workspace.name}</span>
                  {isSelected ? (
                    <IconComponent icon={Icon.CheckmarkRegular} size={20} className={styles.checkmark} />
                  ) : null}
                </button>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
